import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import MlsServiceLogIndexPage from "../applications/mls_service/app/MlsServiceLogIndexPage";
import MlsServiceLogIndexStore from "../applications/mls_service/stores/MlsServiceLogIndexStore";

@observer
class TourMlsServiceLogWidget extends Component {
  render() {
    const { tourId } = this.props;

    const mlsServiceLogIndexStore = new MlsServiceLogIndexStore();

    return <MlsServiceLogIndexPage tourId={tourId} mlsServiceLogIndexStore={mlsServiceLogIndexStore} />;
  }
}

TourMlsServiceLogWidget.propTypes = {
  tourId: PropTypes.number.isRequired,
};

export default TourMlsServiceLogWidget;
